import { fromJS } from 'immutable';
import React from 'react';
import { Badge } from 'reactstrap';

class Timer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            timerConfig: { minutes: 0, seconds: 0 },
            interval: null,
            newInterval: null
        }
    }
    componentDidMount() {
        let { timerIndex } = this.props;
        const { itemProperties } = this.props.layoutItem;
        const { timerConfig } = itemProperties;
        const { forceRefresh } = timerConfig;

        if (timerConfig && timerConfig.refreshSpecificContainer && timerConfig.specificContainer) {
            this.startAutoLoopTimer();
        } else {
            this.stopAutoLoopTimer();
        }

        this.setState({ timerConfig: timerConfig });
        const state = this.state;
        const props = this.props;
        let self = this;
        var tmpseconds = timerConfig.seconds;
        var tmpmiutes = timerConfig.minutes;
        if (!tmpmiutes || tmpmiutes === 0 || tmpmiutes === '0' || tmpmiutes === '') {
            if (!tmpseconds || tmpseconds === 0 || tmpseconds === '0' || tmpseconds === '') {
                props.onSubmit(fromJS(props.workflow.workflowData));
                return;
            }
        }
        const interval = setInterval(function () {
            const { timerConfig } = self.state;
            let { minutes, seconds } = timerConfig;
            if (seconds) {
                seconds--;
            } else if (minutes) {
                minutes--;
                seconds = 59;
            } else {
                if (forceRefresh) {
                    props.refreshWF();

                    seconds = parseInt(this.props.layoutItem.itemProperties.timerConfig.seconds);
                    minutes = this.props.layoutItem.itemProperties.timerConfig.minutes ? parseInt(this.props.layoutItem.itemProperties.timerConfig.minutes) : 0;
                    props.changeTimerIndex(++timerIndex)
                } else {
                    if (timerConfig && !timerConfig.refreshSpecificContainer) {
                        props.onSubmit(fromJS(props.workflow.workflowData));
                    }

                    clearInterval(interval);
                }
            }
            timerConfig.minutes = minutes;
            timerConfig.seconds = seconds;
            self.setState({ timerConfig: timerConfig });
        }.bind(this), 1000);
        self.setState({ interval });
    }

    stopAutoLoopTimer = () => {
        if (this.state.newInterval) {
            clearInterval(this.state.newInterval);
            this.setState({ newInterval: null });
        }
    };

    componentWillUnmount() {
        this.state.newInterval && clearInterval(this.state.newInterval);
        this.stopAutoLoopTimer();
    }


    startAutoLoopTimer = () => {
        const { itemProperties } = this.props.layoutItem;
        const initialConfig = { ...itemProperties.timerConfig };
        this.setState({ timerConfig: initialConfig });

        if (this.state.newInterval) {
            clearInterval(this.state.newInterval);
        }

        const interval = setInterval(() => {

            let { minutes, seconds } = this.state.timerConfig;

            if (seconds > 0) {
                seconds--;
            }
            else if (minutes > 0) {
                minutes--;
                seconds = 59;
            }
            else {
                minutes = parseInt(initialConfig.minutes || 0);
                seconds = parseInt(initialConfig.seconds || 0);
            }

            let isTimer = true
            this.props.toggleContainerTimer(itemProperties && itemProperties.timerConfig, isTimer)
        }, parseInt(initialConfig.seconds * 1000));

        this.setState({ newInterval: interval });
    };


    render() {
        const { timerConfig } = this.state;
        if (!timerConfig) {
            return (<div>Not configured</div>)
        }

        const badgeStyle = {
            minWidth: '40px',
            margin: '0 3px'
        }
        const { minutes, seconds, hideTimer } = timerConfig;
        if (hideTimer) return '';
        return (
            <div>
                <div>
                    {minutes ?
                        <Badge style={badgeStyle} color='primary'>Min</Badge> : null
                    }
                    <Badge style={badgeStyle} color='primary'>Sec</Badge>
                </div>
                <div>
                    {
                        minutes ?
                            <Badge style={badgeStyle} color='primary'>{minutes}</Badge> : null
                    }
                    <Badge style={badgeStyle} color='primary'>{seconds ? seconds : '00'}</Badge>
                </div>
            </div>
        )
    }
}

export default Timer;
